import { SupportedChainId } from 'config/chains'
import { getChainInfo } from 'constants/chainInfo'
import { useContext } from 'react'
import { AlertCircle } from 'react-feather'
import styled, { ThemeContext } from 'styled-components'

import { ThemedText } from '../../theme'
import { AutoColumn } from '../Column'
import { AutoRow } from '../Row'

const RowNoFlex = styled(AutoRow)`
  flex-wrap: nowrap;
`

export default function FailedNetworkSwitchPopup({ chainId }: { chainId: SupportedChainId }) {
  const chainInfo = getChainInfo(chainId)
  const theme = useContext(ThemeContext)

  return (
    <RowNoFlex>
      <div style={{ paddingRight: 16 }}>
        <AlertCircle color={theme.deprecated_red1} size={24} />
      </div>
      <AutoColumn gap="8px">
        <ThemedText.DeprecatedBody fontWeight={500}>
          <>
            Failed to switch networks from the Kodiak Interface. In order to use Kodiak on {chainInfo.label}, you must
            change the network in your wallet.
          </>
        </ThemedText.DeprecatedBody>
      </AutoColumn>
    </RowNoFlex>
  )
}
